<template>
  <div>
    <div class="p-25 b-b-1 bg-white">
      <Steps :current="step">
        <Step title="企业信息"></Step>
        <Step title="选择刻章店"></Step>
        <Step title="选择印章"></Step>
        <Step title="选择取章方式"></Step>
        <Step title="付款"></Step>
      </Steps>
    </div>

    <!-- 第1步, 企业信息 -->
    <div class="p-25 bg-white" v-if="step===0">
      <OrderCompanySelf v-if="currentOrder.orderType==='0'" ref="orderCompanySelf"></OrderCompanySelf>
      <OrderCompanySamr v-else></OrderCompanySamr>

      <div class="p-10 text-c">
        <Button type="primary" @click="step0to1">下一步</Button>
        <Button type="default" class="m-l-10" @click="$router.push('/custom/order/current')">返回</Button>
      </div>
    </div>

    <!-- 第2步, 选择刻章店 -->
    <div class="p-25 bg-white" v-if="step===1">
      <div v-if="currentOrder.seals && currentOrder.seals.length">
        <Row :gutter="10">
          <Col span="24">
            您已选择了刻制企业：{{currentOrder.company?currentOrder.company.name:''}}，并且选择了印章，如需要修改，请先删除所有已经录入的印章。
          </Col>
        </Row>
        <div class="m-t-20 text-c">
          <Button type="primary" @click="gotoStep(0)">上一步</Button>
          <Button type="primary" class="m-l-10" @click="step1to2">下一步</Button>
        </div>
      </div>
      <div v-else>
        <OrderSelectMaker></OrderSelectMaker>
        <div class="m-t-20 text-c">
          <Button type="primary" @click="gotoStep(0)">上一步</Button>
          <Button type="primary" class="m-l-10" @click="step1to2">下一步</Button>
        </div>
      </div>
    </div>

    <!-- 第3步, 选择印章 -->
    <div class="p-25 bg-white" v-if="step===2">
      <OrderSelectSeal></OrderSelectSeal>
      <div class="m-t-20 text-c">
        <Button type="primary" @click="gotoStep(1)">上一步</Button>
        <Button type="primary" class="m-l-10" @click="gotoStep(3)">下一步</Button>
      </div>
    </div>

    <!-- 第4步, 选择取章方式 -->
    <div class="p-25 bg-white" v-if="step===3">
      <OrderSelectDeliver></OrderSelectDeliver>
      <div class="m-t-20 text-c">
        <Button type="primary" @click="gotoStep(2)">上一步</Button>
        <Button type="primary" class="m-l-10" @click="step3to4">下一步</Button>
      </div>
    </div>

    <!-- 第5步, 付款 -->
    <div class="p-25 bg-white" v-if="step===4">
      <OrderPay></OrderPay>
      <div class="m-t-20 text-c">
        <Button type="primary" @click="gotoStep(3)">上一步</Button>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import store from '@/modules'
  import OrderCompanySamr from './OrderCompanySamr'
  import OrderCompanySelf from './OrderCompanySelf'
  import OrderSelectMaker from './OrderSelectMaker'
  import OrderSelectSeal from './OrderSelectSeal'
  import OrderSelectDeliver from './OrderSelectDeliver'
  import OrderPay from './OrderPay'

  export default {
    components: {
      OrderSelectDeliver,
      OrderSelectSeal,
      OrderCompanySamr,
      OrderCompanySelf,
      OrderSelectMaker,
      OrderPay,
    },
    data() {
      return {
        step: 0,
      }
    },
    computed: {
      ...mapState({
        currentOrder: state => state.order.currentOrder,
        companySelected: state => state.order.companySelected,
      }),
    },
    methods: {

      gotoStep(step) {
        console.log(step, this.currentOrder.seals)

        if (step === 3 && (!this.currentOrder.seals || this.currentOrder.seals.length === 0))
          return

        this.step = step
        this.$router.push({path: this.$route.path, query: {id: this.currentOrder.id, step: step}})
      },

      // 保存订单
      step0to1() {
        if (this.currentOrder.orderType==='0') {
          this.$refs.orderCompanySelf.validate().then((valid) => {
            if (valid) {
              // 自助申报的订单, 需要保存
              store.dispatch('order/postSaveOrder').then(() => {
                this.gotoStep(1)
              })
            } else {
              this.$Message.warning('请完整填写表单')
            }
          })
        } else {
          // 市场监督局推送, 直接切换
          this.gotoStep(1)
        }
      },

      // 保存刻章店
      step1to2() {
        if (this.currentOrder.seals && this.currentOrder.seals.length) {
          // 有印章了不能再保存刻章店
          this.gotoStep(2)
        } else {
          // 保存刻章店
          this.$store.dispatch('order/postOrderSubmitCompany', {
            id: this.currentOrder.id,
            companyId: this.companySelected.id
          }).then(() => {
            this.gotoStep(2)
          })
        }
      },

      // 保存取章方式信息
      step3to4() {
        let that = this

        if (this.currentOrder.deliverType==='1' && (!this.currentOrder.deliverDist6 || !this.currentOrder.deliverAddress)) {
          that.$Notice.warn({title: '请填写完整的售货地址'})
        } else {
          store.dispatch('order/postSaveOrder').then(() => {
            this.gotoStep(4)
          })
        }
      },
    },

    created() {
      if (this.$route.query.id) { // 已有订单则从服务器获取订单原有信息
        this.$store.dispatch('order/getOrderById', {id: this.$route.query.id})
      } else { // 新订单
        this.$store.commit('order/SET_INIT_ORDER')
      }

      if (!this.$route.query.step) { // 默认进入第1步
        this.step = 0;
        this.$router.push({
          path: this.$route.path,
          query: Object.assign({}, this.$route.query, {step: this.step})
        })
      } else {
        this.step = parseInt(this.$route.query.step)
      }
    }
  }
</script>
